import { render, staticRenderFns } from "./carlose.vue?vue&type=template&id=65601a5f&scoped=true"
import script from "./carlose.vue?vue&type=script&lang=js"
export * from "./carlose.vue?vue&type=script&lang=js"
import style0 from "./carlose.vue?vue&type=style&index=0&id=65601a5f&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65601a5f",
  null
  
)

export default component.exports